import { type SelectOptions } from "@/components/shared/select-input";

export const mobilityStatus = [
  "Independent",
  "Use Walking aid or needs handhold assistance",
  "Uses wheelchair or is Chair-bound",
  "Bedridden needing full assistance",
];

export const mobilityStatusOptions: SelectOptions = mobilityStatus.map((mobilityStatus) => ({
  value: mobilityStatus,
  label: mobilityStatus,
}));

export const symptoms = [
  "Breathlessness or chest pain",
  "Giddiness",
  "Pain",
  "Physical or Verbal Aggression",
];

export const symptomsValues = symptoms.map((symptom) => ({
  value: symptom,
  selected: false,
}));

export const symptomOptions: SelectOptions = symptoms.map((symptom) => ({
  value: symptom,
  label: symptom,
}));

export const requiredAssistances = [
  "Mobility & Transfers",
  "Bathing & Toileting (including diapering)",
  "Meal Assistance - Feeding, buying of food nearby or preparation of simple meals",
  "Medication Reminders & Serving",
  "Social Companionship & Activities (e.g. Going for walks, coloring)",
  "Light Housekeeping Tasks",
];

export const requiredAssistancesValues = requiredAssistances.map((requiredAssistance) => ({
  value: requiredAssistance,
  selected: false,
}));

export const requiredAssistancesOptions: SelectOptions = requiredAssistances.map(
  (requiredAssistance) => ({
    value: requiredAssistance,
    label: requiredAssistance,
  }),
);

export const ageOptions = Array.from({ length: 40 }, (_, i) => ({
  value: `${60 + i} yrs`,
  label: `${60 + i}`,
})) as SelectOptions;

export const weightOptions = Array.from({ length: 13 }, (_, i) => ({
  value: `${40 + i} kg`,
  label: `${40 + i}`,
})) as SelectOptions;
